
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chat-app-development-company",
      function () {
        return require("private-next-pages/chat-app-development-company.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chat-app-development-company"])
      });
    }
  